module.exports = __webpack_public_path__ + "static/media/DSCF0035.a01a61c4.jpg";